import { render } from "./DashboardOffer.vue?vue&type=template&id=9e393de0&scoped=true"
import script from "./DashboardOffer.vue?vue&type=script&lang=ts"
export * from "./DashboardOffer.vue?vue&type=script&lang=ts"

import "./DashboardOffer.vue?vue&type=style&index=0&id=9e393de0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9e393de0"

export default script